import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import utility from '../../util/utilityfunctions';

export default function docHelperDocumentsReducer(state = initialstate.docHelperDocuments, action) {
	let docHelperDocumentKey;

	switch (action.type) {
		case 'DOCUMENT_DOWNLOAD_PROGRESS':
		case 'DOCUMENT_DOWNLOAD_COMPLETE':
		case 'DOCUMENT_UPLOAD_PROGRESS':
		// eslint-disable-next-line no-case-declarations, no-fallthrough
		case 'DOCUMENT_UPLOAD_COMPLETE': {
			// Scenario: Documents Edit, Save and Close
			// This scenario will have actions dispatched from documentHub directly
			// It will not come from docHelperMiddleware, So the payload will be missing
			// For these scenarios we should handle only the progress bar.
			if (!action.meta.docHelper) {
				if (
					Number(action.meta?.message?.EngagementId) !==
					Number(action.engagementId !== undefined ? action.engagementId : 0)
				) {
					return state;
				}
				let fileName = action.meta.message && action.meta.message.FileName;
				//let itemKey = fileName + '_' + action.meta.message.FileId;

				const documentKeys = utility.GetDocHelperStateKey(state, fileName);
				let newState = {...state};
				for (const itemKey of documentKeys) {
					if (action.type === 'DOCUMENT_UPLOAD_COMPLETE') {
						newState = _.omit(newState, itemKey);
					} else {
						let relatedEntityId = action?.meta?.docHelper?.payload?.relatedEntityId;
						if (!relatedEntityId) {
							let docObjectFromState = newState[itemKey];
							relatedEntityId = docObjectFromState?.relatedEntityId;
						}

						let updatedState = {
							documentId: action.meta.message.FileId,
							inProgress: true,
							progressPercent: action.meta.message.ProgressPercent,
							totalPercentage: 100,
							relatedEntityId: relatedEntityId
						};

						newState = {
							...newState,
							[itemKey]: {
								...newState[itemKey],
								...updatedState
							}
						};
					}
				}

				return newState;
			}

			//get document from state and update only progress
			// For Progress and COmplete only update the progress
			let docObjFromAction = action.meta.docHelper;

			let message = docObjFromAction.message;

			let updatedDocHelperState = {...state};
			if (!message) {
				return updatedDocHelperState;
			}
			let keyToSearch = message.FileName;
			if (action.type === 'DOCUMENT_DOWNLOAD_COMPLETE' || action.type === 'DOCUMENT_DOWNLOAD_PROGRESS') {
				// search key start with message.FileName + "_" + message.FileId in docHelperState
				keyToSearch = message.FileName + '_' + message.FileId;
			}
			let updatedDocHelperStateKeys = utility.GetDocHelperStateKey(state, keyToSearch);
			updatedDocHelperStateKeys.forEach((key) => {
				if (action.type === 'DOCUMENT_DOWNLOAD_COMPLETE') {
					updatedDocHelperState = _.omit(updatedDocHelperState, key);
				} else {
					let docObjectFromState = state[key];
					let inProgress = docObjFromAction && docObjFromAction.payload && docObjFromAction.payload.inProgress;
					let relatedEntityId = action?.meta?.docHelper?.payload?.relatedEntityId;
					if (!relatedEntityId) {
						relatedEntityId = docObjectFromState?.relatedEntityId;
					}

					let updatedState = {
						...docObjectFromState,
						documentId: message.FileId,
						inProgress: inProgress ? inProgress : message.ProgressPercent !== 100,
						progressPercent: message.ProgressPercent,
						totalPercentage: 100,
						relatedEntityId: relatedEntityId
					};
					Object.assign(updatedDocHelperState, updatedDocHelperState, {
						[key]: updatedState
					});
				}
			});

			return updatedDocHelperState;
		}
		case types.DOCHELPER_DOWNLOAD_DOCUMENT:
			if (action.meta && action.meta.docHelper && action.meta.docHelper.payload) {
				let docKey = action.meta.docHelper.payload.dockey;
				if (!docKey) {
					docKey = '';
				}

				docHelperDocumentKey = action.meta.docHelper.payload.documentName + docKey;
				let downloadDocObj = {
					[docHelperDocumentKey]: {
						...state[docHelperDocumentKey],
						...action.meta.docHelper.payload
					}
				};
				return Object.assign({}, state, downloadDocObj) || {};
			}
			return {};
		case types.DOCHELPER_BULK_DOWNLOAD: {
			const {parentName, documentIds} = action;

			if (documentIds && documentIds.length > 0) {
				const bulkDownloads = {};
				documentIds.forEach((docId) => {
					bulkDownloads[docId] = {parentName, inProgress: true};
				});

				return {
					...state,
					...bulkDownloads
				};
			} else {
				return state;
			}
		}
		case 'DOCHELPER_UPLOAD_DOCUMENT': {
			const payload = action.meta.docHelper.docPayload;
			if (payload) {
				return Object.assign(
					{},
					state,
					...payload.map((item, index) => ({
						[action.responseObj.data[index].name]: {...item}
					}))
				);
			}
			return state;
		}
		/*case 'DOCUMENT_UPLOAD_COMPLETE':
			var docHelperObj = {...action.meta.docHelper};
			return _.omit(state, docHelperObj.message.FileName);
			break;*/
		case 'DOCUMENT_UPLOAD_ERROR':
			console.log('document upload error', action);
			//TODO: Handle Upload Error scenario
			break;
		case 'ASSOCIATE_TASK_DOCUMENTS':
		case types.REMOVE_TASK_DOCUMENT:
			if (!action.isOnline) {
				return state;
			}
			return _.omit(state, action.documentName);
		case types.DAAS_DOCUMENT_IN_PROGRESS:
			if (action.payload) {
				let docKey = action.payload.dockey;
				if (!docKey) docKey = '';
				docHelperDocumentKey = action.payload.documentName + docKey;
				if (action.payload.inProgress === true) {
					let downloadDocObj = {
						[docHelperDocumentKey]: {
							...state[docHelperDocumentKey],
							...action.payload
						}
					};
					return Object.assign({}, state, downloadDocObj) || {};
				} else {
					const {[docHelperDocumentKey]: _, ...remaining} = state;
					return remaining;
				}
			}
			return {};
		default:
			return state;
	}
}
